// extracted by mini-css-extract-plugin
export default {"wrapper":"social-linkpost-upload-EditLinkPostModal__wrapper--StfcI"};